import { call, put, takeLeading } from "redux-saga/effects";
import { AnnouncementAPI } from "services/announcement";
import { fetchAnnounceList, fetchAnnounceListSuccess, fetchAnnounceListFailure } from "redux/reducers/announcement";

function* fetchAnnounceListSaga() {
  try {
    const response = yield call(AnnouncementAPI.fetchAnnounceList);
    yield put(
      fetchAnnounceListSuccess(
        response.data.result?.announcementList.sort((a, b) => a.displayPriority - b.displayPriority) ?? []
      )
    );
  } catch (error) {
    yield put(fetchAnnounceListFailure(error));
  }
}

const saga = [takeLeading(fetchAnnounceList.type, fetchAnnounceListSaga)];

export default saga;
